'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const OtherIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="OtherIcon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21.207 4.5C21.3946 4.68749 21.4999 4.9418 21.5 5.207V22.5C21.5 22.7652 21.3946 23.0196 21.2071 23.2071C21.0196 23.3946 20.7652 23.5 20.5 23.5H3.5C3.23478 23.5 2.98043 23.3946 2.79289 23.2071C2.60536 23.0196 2.5 22.7652 2.5 22.5V1.5C2.5 1.23478 2.60536 0.98043 2.79289 0.792893C2.98043 0.605357 3.23478 0.5 3.5 0.5H16.793C17.0582 0.500057 17.3125 0.605451 17.5 0.793L21.207 4.5Z"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.8263 12.3661L10.0263 8.62607C9.97594 8.55896 9.90949 8.50562 9.83308 8.47095C9.75666 8.43628 9.67276 8.42139 9.58908 8.42767C9.50541 8.43395 9.42466 8.46118 9.35427 8.50686C9.28389 8.55254 9.22613 8.6152 9.18632 8.68907L5.91032 14.7631C5.86933 14.8392 5.84879 14.9247 5.85071 15.0112C5.85263 15.0976 5.87694 15.1821 5.92127 15.2564C5.96561 15.3306 6.02844 15.3921 6.10364 15.4348C6.17885 15.4775 6.26384 15.5 6.35032 15.5001H10.5313"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 16C10.5 17.0609 10.9214 18.0783 11.6716 18.8284C12.4217 19.5786 13.4391 20 14.5 20C15.5609 20 16.5783 19.5786 17.3284 18.8284C18.0786 18.0783 18.5 17.0609 18.5 16C18.5 14.9391 18.0786 13.9217 17.3284 13.1716C16.5783 12.4214 15.5609 12 14.5 12C13.4391 12 12.4217 12.4214 11.6716 13.1716C10.9214 13.9217 10.5 14.9391 10.5 16Z"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  )
}

OtherIcon.propTypes = {
  sx: PropTypes.object
}
